// @ts-nocheck

export const parseCurl = (curl: string) => {
  try {
    if (!curl || typeof curl !== 'string') {
      return { url: '', method: 'GET', headers: {}, body: '' };
    }

    curl = curl
      .replace(/\u00A0/g, ' ')
      .replace(/\u200b/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/\\\r?\n/g, ' ')
      .trim();

    const urlMatch = curl.match(/(https?:\/\/[^\s'"]+)/i);
    let url = urlMatch ? urlMatch[1] : '';

    if (url) {
      url = url.replace(/(['%27]+)$/g, '');
      try {
        url = decodeURIComponent(url);
      } catch {
        // ignore
      }
    }

    let method = 'GET';
    const methodMatch = curl.match(/-X\s+(\w+)/i);
    if (methodMatch) method = methodMatch[1].toUpperCase();

    if (/\s-G\s/.test(curl)) method = 'GET';

    const hasDataFlag =
      /\s(--data|-d|--data-raw|--data-binary|--form|-F|--data-urlencode)\s+/.test(curl);
    if (!methodMatch && !/\s-G\s/.test(curl) && hasDataFlag) method = 'POST';

    const headers: Record<string, string> = {};
    const headerMatches = [...curl.matchAll(/(?:-H|--header)\s+['"]?([^'"\n]+)['"]?/gi)];
    headerMatches.forEach((m) => {
      const headerLine = m[1].trim();
      const [key, ...rest] = headerLine.split(':');
      if (key && rest.length) headers[key.trim()] = rest.join(':').trim();
    });

    const dataFlags = ['-d', '--data', '--data-raw', '--data-binary', '--form', '-F'];
    let body = '';

    for (const flag of dataFlags) {
      const matchQuoted = curl.match(new RegExp(`${flag}\\s+(['"])([\\s\\S]*?)\\1`));
      if (matchQuoted) {
        body = matchQuoted[2].trim();
        break;
      }
      const matchUnquoted = curl.match(new RegExp(`${flag}\\s+([^\\s]+)`));
      if (matchUnquoted) {
        body = matchUnquoted[1].trim();
        break;
      }
    }

    const params: string[] = [];
    const urlEncodeRegex = /--data-urlencode\s+(?:'([^']+)'|"([^"]+)"|([^\s]+))/gi;
    let encoded;
    while ((encoded = urlEncodeRegex.exec(curl)) !== null) {
      const param = encoded[1] || encoded[2] || encoded[3];
      params.push(param.trim());
    }

    if (method === 'GET' && params.length) {
      const query = params.join('&');
      url += (url.includes('?') ? '&' : '?') + query;
    }

    if (body && method !== 'GET') {
      try {
        const parsedBody = JSON.parse(body);
        body = JSON.stringify(parsedBody);
      } catch {
      }
    }

    return { url, method, headers, body };
  } catch (error) {
    console.error('Error parsing curl:', error);
    return { url: '', method: 'GET', headers: {}, body: '' };
  }
};


export const looksLikeCurl = (value: string) => {
  const cleaned = (value || '')
    .trim()
    .replace(/^\$+\s*/, '')
    .toLowerCase();
  return cleaned.startsWith('curl ') || cleaned.startsWith('curl\t');
};


export const guessParamType = (value: any) => {
  if (Array.isArray(value)) return 'array';
  if (value !== null && typeof value === 'object') return 'object';
  if (typeof value === 'boolean') return 'boolean';
  if (typeof value === 'number') return Number.isInteger(value) ? 'integer' : 'number';
  return 'string';
};
